// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let DialogV5 = require("../../../uikit/reason/molecules/Dialog/DialogV5.bs.js");
let ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let ReactRender = require("../../../reason/utils/ReactRender.bs.js");
let Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let Form__TextAreaField = require("../../../uikit/reason/atoms/Form/Form__TextAreaField.bs.js");
let InlineWarning__Jsx3 = require("../../../uikit/reason/atoms/InlineWarning/InlineWarning__Jsx3.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let MarkBuyerNeedAsPurchasedDialogMutation_graphql = require("../../../__generated__/MarkBuyerNeedAsPurchasedDialogMutation_graphql.bs.js");

let convertVariables = MarkBuyerNeedAsPurchasedDialogMutation_graphql.Internal.convertVariables;

let convertResponse = MarkBuyerNeedAsPurchasedDialogMutation_graphql.Internal.convertResponse;

let convertWrapRawResponse = MarkBuyerNeedAsPurchasedDialogMutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables, MarkBuyerNeedAsPurchasedDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let use = RescriptRelay_Mutation.useMutation(convertVariables, MarkBuyerNeedAsPurchasedDialogMutation_graphql.node, convertResponse, convertWrapRawResponse);

let MarkBuyerNeedPurchasedMutation = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use
};

function MarkBuyerNeedAsPurchased(props) {
  let close = props.close;
  let nodeId = props.nodeId;
  let match = use();
  let mutate = match[0];
  let match$1 = React.useState(() => "");
  let setComment = match$1[1];
  let comment = match$1[0];
  let match$2 = React.useState(() => "Idle");
  let setSubmissionStatus = match$2[1];
  let submissionStatus = match$2[0];
  let __x = submissionStatus === "SubmissionError";
  return JsxRuntime.jsx(DialogV5.make, {
    title: "Mark buyer need as purchased",
    isOpen: props.isOpen,
    ariaLabel: "Mark buyer need as purchased",
    onDismiss: () => close(),
    size: "Large",
    children: JsxRuntime.jsx("form", {
      children: JsxRuntime.jsxs(ViewStack.make, {
        children: [
          JsxRuntime.jsx("div", {
            children: "Once this buyer need is marked as purchased, it will no longer be active for new matches on TAN. The new TAN status and your comments will show to TAN members on existing matches."
          }),
          JsxRuntime.jsx(Form__TextAreaField.make, {
            labelText: "Comments",
            optionalText: "optional",
            onChange: evt => setComment(evt.target.value),
            value: comment
          }),
          ReactRender.ifTrue(JsxRuntime.jsx(InlineWarning__Jsx3.make, {
            children: "There was a problem updating the buyer need. Please try again."
          }), __x),
          JsxRuntime.jsxs(ViewStack.make, {
            mt: "lg",
            space: "sm",
            justifyContent: "flexEnd",
            flexDirection: "row",
            children: [
              JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                onClick: param => close(),
                disabled: submissionStatus === "Loading",
                size: "medium",
                _type: "button",
                children: "Cancel"
              }),
              JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                disabled: submissionStatus === "Loading",
                children: "Mark as purchased"
              })
            ]
          })
        ]
      }),
      onSubmit: event => {
        event.preventDefault();
        setSubmissionStatus(param => "Loading");
        mutate({
          input: {
            comment: Form__Helpers.opt_of_string(comment),
            nodeId: nodeId
          }
        }, undefined, undefined, undefined, (param, param$1) => {
          let markBuyerNeedPurchased = param.markBuyerNeedPurchased;
          if (markBuyerNeedPurchased === undefined) {
            return setSubmissionStatus(param => "SubmissionError");
          }
          if (markBuyerNeedPurchased.__typename !== "BuyerNeedMarkedPurchased") {
            return setSubmissionStatus(param => "SubmissionError");
          }
          close();
          setSubmissionStatus(param => "Idle");
          setComment(param => "");
        }, param => setSubmissionStatus(param => "SubmissionError"), undefined);
      }
    })
  });
}

let make = MarkBuyerNeedAsPurchased;

exports.MarkBuyerNeedPurchasedMutation = MarkBuyerNeedPurchasedMutation;
exports.make = make;
/* commitMutation Not a pure module */
